(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Four-Col-Slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const videoCovers = document.querySelectorAll('.video-cover');
    const closeButtons = document.querySelectorAll('.close-popup');

    videoCovers.forEach(cover => {
      cover.addEventListener('click', function() {
        const videoId = this.dataset.videoId;
        const popup = document.getElementById(`video-popup-${videoId}`);
        if (popup) popup.classList.add('open');
      });
    });

    closeButtons.forEach(button => {
      button.addEventListener('click', function() {
        const popup = this.closest('.video-popup');
        if (popup) {
          popup.classList.remove('open');
          const video = popup.querySelector('.popup-video');
          if (video) video.pause();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
